export default "__VITE_ASSET__1HmNQ_zB__"